import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import ProductCard from "../components/storefront/ProductCard";
import { Button } from "../components/ui/button";
import { ArrowRight } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { imageUrl } from "../lib/format";

export default function Home() {
  const [nouveautes, setNouveautes] = useState([]);
  const { content } = useContent();

  useEffect(() => {
    api.get("/products", { params: { tag: "nouveau", limit: 4, sort: "recent" } })
      .then(async (r) => {
        let items = r.data.items || [];
        if (items.length < 4) {
          const fill = await api.get("/products", { params: { limit: 10, sort: "recent" } });
          const ids = new Set(items.map((p) => p.id));
          for (const p of (fill.data.items || [])) {
            if (items.length >= 4) break;
            if (!ids.has(p.id)) { items.push(p); ids.add(p.id); }
          }
        }
        setNouveautes(items.slice(0, 4));
      })
      .catch(() => {});
  }, []);

  if (!content) return <div className="py-32 text-center text-[#9B7E73]">Chargement...</div>;
  const { hero, nouveautes: nv, story_home: story } = content;

  return (
    <div>
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src={imageUrl(hero.image)} alt="Le Dressing de Yoyo" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#2C1A14]/85 via-[#2C1A14]/50 to-transparent" />
        </div>
        <div className="relative mx-auto flex max-w-7xl flex-col items-start px-4 py-24 sm:px-6 sm:py-32 lg:px-8 lg:py-40">
          <span className="mb-4 rounded-full border border-white/40 px-4 py-1 text-xs uppercase tracking-[0.25em] text-white/90">
            {hero.badge}
          </span>
          <h1 className="max-w-2xl font-serif text-4xl font-semibold leading-tight text-white sm:text-5xl lg:text-6xl">
            {hero.title_line1} <span className="font-script text-[#F0B49A]">{hero.title_script}</span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-[#F3E6E0] sm:text-lg">{hero.subtitle}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/catalog">
              <Button data-testid="hero-cta-button" className="rounded-full bg-[#D76E4D] px-7 py-6 text-base text-white hover:bg-[#C05A3A]">
                {hero.cta_primary} <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <Link to="/histoire">
              <Button variant="outline" data-testid="hero-story-button" className="rounded-full border-white/60 bg-transparent px-7 py-6 text-base text-white hover:bg-white/10 hover:text-white">
                {hero.cta_secondary}
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* NOUVEAUTES */}
      <section id="nouveautes" className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8 lg:py-20">
        <div className="mb-8 flex items-end justify-between">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-[#D76E4D]">{nv.eyebrow}</p>
            <h2 className="mt-2 font-serif text-2xl font-medium text-[#2C1A14] sm:text-3xl lg:text-4xl">{nv.title}</h2>
          </div>
          <Link to="/catalog?tag=nouveau" data-testid="see-all-new" className="hidden text-sm font-medium text-[#D76E4D] hover:underline sm:block">
            Tout voir →
          </Link>
        </div>
        {nouveautes.length === 0 ? (
          <p className="text-[#9B7E73]">Bientôt de nouvelles pièces...</p>
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-6 lg:grid-cols-4">
            {nouveautes.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        )}
      </section>

      {/* NOTRE HISTOIRE */}
      <section className="bg-[#F5E8E3]">
        <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:px-8 lg:py-24">
          <div className="aspect-[4/5] max-h-[560px] overflow-hidden rounded-2xl">
            <img src={imageUrl(story.image)} alt="Yolande, Yoyo" className="h-full w-full object-cover" />
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-[#D76E4D]">{story.eyebrow}</p>
            <h2 className="mt-2 font-serif text-2xl font-medium text-[#2C1A14] sm:text-3xl lg:text-4xl">{story.title}</h2>
            <p className="mt-5 text-base leading-relaxed text-[#6E544A]">{story.text}</p>
            <Link to="/histoire">
              <Button data-testid="read-story-button" className="mt-7 rounded-full bg-[#D76E4D] px-6 text-white hover:bg-[#C05A3A]">
                {story.button} <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
